<template>
  <div class="content_bg">
    <div class="topContent">
        <div class="dh_wz">
          <div class="dh_wz_qq">
            
          </div>
          <div class="dh_wz_tb"></div>
          <div class="dh_wz_wz">项目进度</div>
        </div>
        <div class="dh_lb">
          <router-link :to="{path:'/gbzntyj'}"><div class="dh_lb_bt">项目总览</div></router-link>
          <router-link :to="{path:'/plant'}"><div class="dh_lb_bt">高标准农田</div></router-link>
           <!-- <router-link :to="{path:'/gbzntjs'}"><div class="dh_lb_bt dh_lb_bt_cur">项目进度</div></router-link> -->
          <!-- <router-link :to="{path:'/zuowufenxi'}"><div class="dh_lb_bt">农作物分析</div></router-link> -->
          <router-link :to="{path:'/zhinengGG'}"><div class="dh_lb_bt">智能灌溉</div></router-link>
          <router-link :to="{path:'/binghai'}"><div class="dh_lb_bt">病虫害管理</div></router-link>
          <!-- <router-link :to="{path:'/plantmoxing'}"><div class="dh_lb_bt">种植模型</div></router-link> -->
          <!-- <router-link :to="{path:'/suyuan'}"><div class="dh_lb_bt">农业溯源</div></router-link> -->
          <!-- <router-link :to="{path:'/qihouYj'}"><div class="dh_lb_bt">气候灾害预警</div></router-link> -->
        </div>
        <div class="titleRightImg">
          <router-link :to="{ path: '/' }"><img src="../assets/img/gbzntyj/sy.png" class="return"/></router-link>
          <img src="../assets/img/gbzntyj/fh.png" class="return"  @click="clickReturn"/>
        </div>
      </div>
    <div class="content_bottom">
      <div class="c_b_left">
        <div class="left_top">
          <div class="l_t_gy1"></div>
          <div class="l_t_gy2"></div>
          <h5>可视化大数据分析</h5>
          <div class="fx_nr">
            <div class="nr_q">
              <div class="bgimg"></div>
              <span class="sum">1500</span>
              <span class="name">今日访问量</span>
            </div>
            <div class="nr_qx"></div>
            <div class="nr_q">
              <div class="bgimg"></div>
              <span class="sum">130</span>
              <span class="name">在线人数</span>
            </div>
            <div class="nr_qx"></div>
            <div class="nr_q">
              <div class="bgimg"></div>
              <span class="sum">4500</span>
              <span class="name">用户总数</span>
            </div>
          </div>
        </div>
        <div class="left_middle">
          <div class="l_t_gy1"></div>
          <div class="l_t_gy2"></div>
          <div class="l_m_bt">
            <div class="bt_jk"></div>
            <div class="bt_name">视频监控</div>
          </div>
          <div class="n_sxt" id="n_sxt">
            <!-- <vue3VideoPlay
              width="100%"
              height="100%"
              title="冰河世纪"
              :src="options.src"
              :type="options.type"
              :autoPlay="true"
              @play="onPlay"
              :control="false"  :controlBtns="false"
            /> -->
            <iframe
              :src="options.src"
              width="100%"
              height="100%"
              id="ysOpenDevice"
              allowfullscreen
            >
            </iframe>
          </div>
        </div>
        <div class="left_bottom">
          <div class="l_t_gy1"></div>
          <div class="l_t_gy2"></div>
          <div class="l_m_bt">
            <div class="bt_jk"></div>
            <div class="bt_name">高标准结构图</div>
          </div>
          <div class="n_sxt">
            <img class="jgimg" src="../assets/img/gbzntjsyzt/img/jgt.jpg" />
          </div>
        </div>
      </div>
      <div class="c_b_middle">
        <div class="middle_top">
          <div class="l_t_gy1"></div>
          <div class="l_t_gy2"></div>
          <div class="m_t_sp" id="m_t_sp">
            <vue3VideoPlay
              width="100%"
              height="100%"
              title="冰河世纪"
              :src="options1.src"
              :type="options1.type"
              :autoPlay="true"
              @play="onPlay"
              :control="false"  :controlBtns="false"
            />
          </div>
        </div>
        <div class="middle_middle">
          <div class="l_t_gy1"></div>
          <div class="l_t_gy2"></div>
          <div class="l_m_bt">
            <div class="bt_jk"></div>
            <div class="bt_name">项目进度</div>
          </div>
          <div class="jd_sp">
            <div class="jd_sp_n"><img src="../assets/img/gbzntjsyzt/1.jpg"/></div>
            <div class="jd_sp_n"><img src="../assets/img/gbzntjsyzt/2.jpg"/></div>
            <div class="jd_sp_n"><img src="../assets/img/gbzntjsyzt/3.jpg"/></div>
            <div class="jd_sp_n"><img src="../assets/img/gbzntjsyzt/4.jpg"/></div>
          </div>
          <div class="jdt">
            <div class="jdt_n">
              <dv-percent-pond
                :config="config"
                style="width: 100%; height: 100%; font-size: 13px !important"
              />
            </div>
          </div>
        </div>
        <!-- <div class="middle_bottom">
          <div class="middle_bottom_dh">
            <div class="dh_left">服务</div>
            <div class="dh_zj">建设</div>
            <div class="dh_middle"></div>
            <div class="dh_right"><router-link :to="{path:'/gbzntyj'}">运营</router-link></div>
          </div>
        </div> -->
      </div>
      <div class="c_b_right">
        <div class="right_top">
          <div class="l_t_gy1"></div>
          <div class="l_t_gy2"></div>
          <div class="c_b_r_bt">项目投资概况</div>
          <div class="c_b_js">
            <txtScroll>
              <div v-for="item in textList" :key="item.id" class="scroll_item">
                {{ item.title }}
              </div>
            </txtScroll>
          </div>
        </div>
        <div class="right_middle">
          <div class="l_t_gy1"></div>
          <div class="l_t_gy2"></div>
          <div class="r_m_fx">
            <rightPie />
          </div>
        </div>
        <div class="right_bottom">
          <div class="l_t_gy1"></div>
          <div class="l_t_gy2"></div>
          <router-link :to="{path:'/zhinengGG'}">
          <div class="l_m_bt">
            <div class="bt_jk"></div>
            <div class="bt_name">灌溉方式及面积</div>
          </div>
          </router-link>
          <div class="r_b_nr">
            <div class="r_b_nr_l">
              <div class="nr_ls">平移喷灌(8400亩)</div>
              <div class="nr_ls">周定喷灌(4008亩)</div>
              <div class="nr_ls">低压管灌(1000亩)</div>
              <div class="nr_ls">老盘式顺灌(1000亩)</div>
            </div>
            <div class="r_b_nr_r">
              <rigsbq />
            </div>
            <!-- <div class="zngg" >智能灌溉</div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="db_bg"></div>
  </div>
  <footer1 />
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from 'vue-router'
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";
import txtScroll from "../components/xiaofeiChanpin/txtScroll.vue";
import rightPie from "../components/gbzntjs/rightPie.vue";
import rigsbq from "../components/gbzntjs/rigsbq.vue";
import footer1 from "../components/footer.vue";
// import Left1Line from "../components/cangchu/left1Line";

export default {
  name: "Home",
  setup() {
    // const timer = ref(null);
    const router = useRouter();
    const state = reactive({
      currentTime: "",
      options: {
        src: "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538489/1.live&autoplay=1&accessToken=at.a8q34juc97jvnred7jgwbb7z8kf0hl96-4jnwanljz4-03c7m86-nxmntojuy", //视频源
        type: "m3u8", //视频类型
      },
      options1: {
        src: require("@/assets/video/jindu.mp4"), //视频源
        type: "video/mp4", //视频类型
      },
      config: {
        colors: ["#03947B", "#03947B"],
        value: 30,
        borderWidth: 1,
        borderRadius: 3,
        borderGap: 1,
      },
      textList: [
        {
          title:
            "高标准农田是指在一定时期内，按照国家相关标准和规划要求，在适宜农业生产区域建设的综合生产能力和生态环境良好的永久基本农田。它具有以下几个显著特征：",
        },
        {
          title:
            "高产稳产：通过土地平整、土壤改良、灌溉排水设施完善等措施，提高农田产出能力，确保粮食和其他农产品稳定高产。",
        },
        {
          title:
            "集中连片：农田布局合理，田块规整，便于规模化、机械化作业和统一管理，降低生产成本，提高劳动效率。",
        },
        {
          title:
            "设施配套：配备完善的水利、电力、道路等基础设施，包括但不限于节水灌溉系统、排涝防洪设施、田间道路网等，以满足现代农业生产和经营需要。",
        },
        {
          title:
            "生态友好：注重农田生态保护与修复，实施耕地质量保护提升工程，强化农业面源污染治理，实现农田可持续利用。",
        },
        {
          title:
            "信息化程度高：推广现代信息技术应用，如遥感监测、物联网技术、精准农业等，提升农田管理智能化水平。",
        },
        {
          title:
            "信息化程度高：推广现代信息技术应用，如遥感监测、物联网技术、精准农业等，提升农田管理智能化水平。",
        },
      ],
    });
    // 返回上一页
    function clickReturn(){
      router.go(-1);
    }
    onMounted(() => {
      // clearInterval(state.timer.value);
      // state.value = setInterval(() => {
      //   state.currentTime = proxy.$utils.getCurrentTime();
      // }, 1000);
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });

    return {
      ...toRefs(state),
      clickReturn
    };
  },
  components: {
    txtScroll,
    rightPie,
    rigsbq,
    footer1
  },
};
</script>
<style lang="less" scoped>
::v-deep .dv-percent-pond text{
  font-size: 20px;
}
.content_bg {
  width: 100%;
  height: 100%;
  background: url("../assets/img/gbzntjsyzt/img/bj.jpg") no-repeat top center;
  background-size: 100% 100%;
  overflow: hidden;

  position: relative;
 .topContent {
    width: 100%;
    height: 90px;
    position: relative;
     .dh_wz {
    width: 170px;
    height: 47px;
    position: absolute;
    left: 3%;
    top: 20%;
    background: url("../assets/img/gbzntyj/yy.png") no-repeat top center;
    background-size: 100% 100%;

    .dh_wz_qq {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      position: absolute;
      top: 6px;
      left: 7px;
      border: 1px solid #ffc600; /* 添加一个黑色的边框 */
      animation: guangying 2s linear infinite;
    }
    .dh_wz_tb {
        width: 20px;
        height: 20px;
        position: absolute;
        left: 15px;
        top: 14px;
        background: url("../assets/img/gbzntyj/nt.png") no-repeat top center;
        background-size: 100% 100%;
        animation: topIcon 2s linear infinite;
        
      }
    .dh_wz_wz {
      width: 120px;
      height: 47px;
      line-height: 47px;
      color: #fff;
      font-size: 20px;
      font-weight: 500;
      text-align: center;
      position: absolute;
      right: 5%;
    }
  }
  .dh_lb {
    // width: 900px;
    height: 45px;
    position: absolute;
    left: 23%;
    top: 20%;
    display: flex;
    flex-flow: row;
    a{
      text-decoration: none;
    }

    .dh_lb_bt {
      width: 124px;
      height: 43px;
      background: url("../assets/img/gbzntyj/yy.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #3bf4be;
      transition: all 0.5s ease-out;
    }
    .dh_lb_bt:hover,.dh_lb_bt_cur {
      width: 124px;
      height: 43px;
      cursor: pointer;
      background: url("../assets/img/gbzntyj/xz.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #fff;
    }
  }
    .titleRightImg {
      position: absolute;
      right: 0;
      top: 27%;
      .return {
        width: 77px;
        height: 32px;
        margin-right: 15px;
        cursor: pointer;
        position: relative;
        z-index: 999;
      }
    }
  }
  .content_bottom {
    width: 100%;
    height: calc(100% - 106px);
    // margin-top: 1%;
    display: flex;
    flex-flow: row wrap;
    .c_b_left {
      width: 518px;
      height: 100%;
      margin-left: 27px;

      display: flex;
      flex-direction: column;
      .left_top {
        position: relative;
        width: 100%;
        height: 188px;
        background: url("../assets/img/gbzntjsyzt/img/z1.png") no-repeat top
          center;
        background-size: 100% 100%;
        h5 {
          width: 100%;
          height: 40px;
          color: #fff;
          text-align: left;
          font-size: 15px;
          font-weight: 600;
          text-indent: 3em;
          line-height: 40px;
          letter-spacing: 3px;
          margin-top: 15px;
        }
        .l_t_gy1 {
          width: 330px;
          height: 100px;
          background: url("../assets/img/gbzntjsyzt/img/gy.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: -27%;
          animation: bianda 3s linear infinite;
        }
        .l_t_gy2 {
          width: 330px;
          height: 100px;
          background: url("../assets/img/gbzntjsyzt/img/gy.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          bottom: -23%;
          left: 30%;
          animation: bianda 3s linear infinite;
        }
        .fx_nr {
          width: 90%;
          margin-left: 10%;
          height: 160px;
          display: flex;
          flex-flow: row wrap;

          .nr_q {
            width: 104px;
            height: 104px;
            margin-left: 9px;
            margin-right: 9px;
            position: relative;
            margin-top: 10px;

            // background: url("../assets/img/gbzntjsyzt/img/gq.png") no-repeat top
            //   center;
            // background-size: 100% 100%;
            .bgimg {
              width: 104px;
              height: 104px;
              background: url("../assets/img/gbzntjsyzt/img/yqq.png") no-repeat
                top center;
              background-size: 100% 100%;
              position: absolute;
              animation: guangying 5s linear infinite;
            }
            .sum {
              display: block;
              font-size: 16px;
              color: #fff;
              width: 100%;
              // height: 30px;
              // line-height: 30px;
              text-align: center;
              margin-top: 35px;
            }
            .name {
              display: block;
              font-size: 13px;
              color: #fff;
              width: 100%;
              // height: 20px;
              // line-height: 20px;
              text-align: center;
            }
          }
          .nr_qx {
            width: 27px;
            height: 34px;
            margin-top: 43px;
            background: url("../assets/img/gbzntjsyzt/img/jt.png") no-repeat top
              center;
            background-size: 100% 100%;
          }
        }
      }
      .left_middle {
        position: relative;
        width: 95%;
        flex: 1;
        margin-top: 27px;
        margin-bottom: 24px;
        background: url("../assets/img/gbzntjsyzt/img/z2.png") no-repeat top
          center;
        background-size: 100% 100%;
        margin-left: 5%;
        .l_t_gy1 {
          width: 330px;
          height: 30%;
          background: url("../assets/img/gbzntjsyzt/img/gy.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: -15%;
          animation: bianda 3s linear infinite;
        }
        .l_t_gy2 {
          width: 330px;
          height: 30%;
          background: url("../assets/img/gbzntjsyzt/img/gy.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          bottom: -13.5%;
          left: 30%;
          animation: bianda 3s linear infinite;
        }
        .l_m_bt {
          width: 100%;
          height: 50px;
          position: relative;
          .bt_jk {
            width: 95px;
            height: 90px;
            background: url("../assets/img/gbzntjsyzt/img/jk.png") no-repeat top
              center;
            background-size: 100% 100%;
            position: absolute;
          }
          .bt_name {
            width: 150px;
            height: 50px;
            color: #fff;
            text-align: left;
            font-size: 15px;
            font-weight: 600;
            text-indent: 3em;

            letter-spacing: 3px;
            position: absolute;

            left: 8%;
            top: 72%;
          }
        }
        .n_sxt {
          position: absolute;
          width: 90%;
          height: 70%;
          left: 5%;
          top: 25%;
          // border: 2%;
          // border: #fff 1px solid;
        }
      }
      .left_bottom {
        position: relative;
        width: 95%;
        margin-bottom: 15px;
        background: url("../assets/img/gbzntjsyzt/img/z2.png") no-repeat top
          center;
        background-size: 100% 100%;
        flex: 1;
        margin-left: 5%;
        .l_t_gy1 {
          width: 330px;
          height: 30%;
          background: url("../assets/img/gbzntjsyzt/img/gy.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: -15%;
          animation: bianda 3s linear infinite;
        }
        .l_t_gy2 {
          width: 330px;
          height: 30%;
          background: url("../assets/img/gbzntjsyzt/img/gy.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          bottom: -13.5%;
          left: 30%;
          animation: bianda 3s linear infinite;
        }
        .l_m_bt {
          width: 100%;
          height: 50px;
          position: relative;
          .bt_jk {
            width: 95px;
            height: 90px;
            background: url("../assets/img/gbzntjsyzt/img/jg.png") no-repeat top
              center;
            background-size: 100% 100%;
            position: absolute;
          }
          .bt_name {
            width: 200px;
            height: 50px;
            color: #fff;
            text-align: left;
            font-size: 15px;
            font-weight: 600;
            text-indent: 3em;
            letter-spacing: 3px;
            position: absolute;
            left: 8%;
            top: 75%;
          }
        }
        .n_sxt {
          position: absolute;
          width: 90%;
          height: 70%;
          left: 5%;
          top: 25%;
          // border: 2%;
          // border: #fff 1px solid;
          .jgimg {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .c_b_middle {
      height: 100%;
      flex: 1;
      margin-left: 49px;
      margin-right: 49px;
      display: flex;
      flex-direction: column;
      .middle_top {
        position: relative;
        width: 100%;
        height: 485px;
        margin-top: 50px;
        background: url("../assets/img/gbzntjsyzt/img/xck.png") no-repeat top
          center;
        background-size: 100% 100%;
        .l_t_gy1 {
          width: 330px;
          height: 100px;
          background: url("../assets/img/gbzntjsyzt/img/gy.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: -10%;
          animation: bianda 3s linear infinite;
        }
        .l_t_gy2 {
          width: 330px;
          height: 100px;
          background: url("../assets/img/gbzntjsyzt/img/gy.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          bottom: -9%;
          left: 20%;
          animation: bianda 3s linear infinite;
        }

        .m_t_sp {
          width: 90%;
          height: 90%;
          top: 6%;
          left: 5%;
          // border: #fff 1px solid;
          position: absolute;
        }
      }
      .middle_middle {
        position: relative;
        width: 100%;
        margin-top: 24px;
        background: url("../assets/img/gbzntjsyzt/img/jd.png") no-repeat top
          center;
        background-size: 100% 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-bottom: 15px;
        text {
          font-size: 15px !important;
          font-weight: bold;
          text-anchor: middle;
          dominant-baseline: middle;
        }
        .l_t_gy1 {
          width: 330px;
          height: 30%;
          background: url("../assets/img/gbzntjsyzt/img/gy.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: -15%;
          animation: bianda 3s linear infinite;
        }
        .l_t_gy2 {
          width: 330px;
          height: 30%;
          background: url("../assets/img/gbzntjsyzt/img/gy.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          bottom: -13.5%;
          left: 50%;
          animation: bianda 3s linear infinite;
        }
        .l_m_bt {
          width: 100%;
          height: 50px;
          position: relative;
          .bt_jk {
            width: 95px;
            height: 90px;
            background: url("../assets/img/gbzntjsyzt/img/jg.png") no-repeat top
              center;
            background-size: 100% 100%;
            position: absolute;
            top: -37%;
          }
          .bt_name {
            width: 200px;
            height: 50px;
            color: #fff;
            text-align: left;
            font-size: 15px;
            font-weight: 600;
            text-indent: 3em;
            letter-spacing: 3px;
            position: absolute;
            left: 5%;
            top: 40%;
          }
        }
        .jd_sp {
          width: 90%;
          flex: 1;
          // left: 4%;
          // top: 28%;
          // border: #fff 1px solid;
          box-sizing: border-box;
          // position: absolute;
          display: flex;
          flex-flow: row wrap;
          justify-content: space-between;
          align-items: center;
          margin-left: 4%;
          .jd_sp_n {
            width: 160px;
            height: 120px;
            border: 1px solid #407262;
            padding: 2px;
            img{
              width: 100%;
              height: 100%;
            }
          }
        }
        .jdt {
          width: 90%;
          height: 26%;
          // position: absolute;
          background: url("../assets/img/gbzntjsyzt/img/jdt.png") no-repeat top
            center;
          background-size: 100% 100%;
          // left: 5%;
          // top: 70%;
          position: relative;
          margin-left: 5%;

          .jdt_n {
            position: absolute;
            left: 10%;
            width: 80%;
            top: 10%;
            height: 40%;
          }
        }
      }
      .middle_bottom {
        width: 100%;
        height: 60px;

        .middle_bottom_dh {
          width: 300px;
          height: 100%;
          position: relative;
          left: 29%;
          top: 30%;
          display: flex;
          flex-flow: row wrap;
          color: #fff;
          .dh_left {
            width: 71px;
            height: 26px;
            margin-top: 10px;
            background: url("../assets/img/gbzntjsyzt/img/zan.png") no-repeat
              top center;
            background-size: 100% 100%;
            font-size: 14px;
            line-height: 26px;
            cursor: pointer;
            animation: daxiao 1s linear infinite;
          }
          .dh_zj {
            width: 144px;
            height: 46px;
            font-size: 17px;
            line-height: 46px;
            font-weight: 700;
            position: absolute;
            z-index: 1000;
            left: 24%;
          }
          .dh_middle {
            width: 144px;
            height: 46px;
            position: relative;
            background: url("../assets/img/gbzntjsyzt/img/xz.png") no-repeat top
              center;
            background-size: 100% 100%;
            animation: bianda 4s linear infinite;
          }
          .dh_right {
            width: 71px;
            height: 26px;
            margin-top: 10px;
            background: url("../assets/img/gbzntjsyzt/img/yan.png") no-repeat
              top center;
            background-size: 100% 100%;
            font-size: 14px;
            line-height: 26px;
            cursor: pointer;
            animation: daxiao 1s linear infinite;
            a{
              color: #fff;
              text-decoration: none;
            }
          }
          .dh_right:hover,.dh_left:hover{
            transform: scale(1.2);
            transition: all 0.5s ease-out;
          }
        }
      }
    }
    .c_b_right {
      width: 464px;
      height: 100%;
      margin-right: 27px;
      display: flex;

      flex-direction: column;
      // position: relative;
      .right_top {
        position: relative;
        width: 100%;
        height: 188px;
        background: url("../assets/img/gbzntjsyzt/img/y1.png") no-repeat top
          center;
        background-size: 100% 100%;
        .l_t_gy1 {
          width: 200px;
          height: 100px;
          background: url("../assets/img/gbzntjsyzt/img/gy.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: -27%;
          right: 0%;
          animation: bianda 3s linear infinite;
        }
        .l_t_gy2 {
          width: 330px;
          height: 100px;
          background: url("../assets/img/gbzntjsyzt/img/gy.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          bottom: -25%;
          left: 30%;
          animation: bianda 3s linear infinite;
        }
        .c_b_r_bt {
          width: 95%;
          height: 40px;
          color: #fff;
          text-align: right;
          font-size: 15px;
          font-weight: 600;
          text-indent: 3em;
          line-height: 40px;
          letter-spacing: 3px;
          margin-top: 15px;
        }
        .c_b_js {
          width: 85%;
          height: 110px;
          // margin-top: 10px;
          margin-left: 4%;
          // border: #fff 1px solid;
          overflow: hidden;

          .scroll_item {
            width: 100%;
            // height: 40px;
            color: #fff;
            text-align: left;
            line-height: 20px;
            font-size:12px
          }
        }
      }
      .right_middle {
        position: relative;
        width: 95%;
        margin: 27px 0 24px 0;
        background: url("../assets/img/gbzntjsyzt/img/y2.png") no-repeat top
          center;
        background-size: 100% 100%;
        flex: 1;
        .l_t_gy1 {
          width: 330px;
          height: 30%;
          background: url("../assets/img/gbzntjsyzt/img/gy.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: -15%;
          animation: bianda 3s linear infinite;
        }
        .l_t_gy2 {
          width: 330px;
          height: 30%;
          background: url("../assets/img/gbzntjsyzt/img/gy.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          bottom: -13.5%;
          left: 20%;
          animation: bianda 3s linear infinite;
        }
        .r_m_fx {
          width: 86%;
          height: 90%;
          position: absolute;
          top: 5%;
          left: 7%;
        }
      }
      .right_bottom {
        position: relative;
        width: 95%;
        background: url("../assets/img/gbzntjsyzt/img/y3.png") no-repeat top
          center;
        background-size: 100% 100%;
        flex: 1;
        margin-bottom: 15px;
        .l_t_gy1 {
          width: 330px;
          height: 30%;
          background: url("../assets/img/gbzntjsyzt/img/gy.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: -15%;
          animation: bianda 3s linear infinite;
        }
        .l_t_gy2 {
          width: 330px;
          height: 30%;
          background: url("../assets/img/gbzntjsyzt/img/gy.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          bottom: -13.5%;
          left: 20%;
          animation: bianda 3s linear infinite;
        }
        .l_m_bt {
          width: 100%;
          height: 50px;
          position: relative;
          .bt_jk {
            width: 95px;
            height: 90px;
            background: url("../assets/img/gbzntjsyzt/img/jk.png") no-repeat top
              center;
            background-size: 100% 100%;
            position: absolute;
          }
          .bt_name {
            width: 200px;
            height: 50px;
            color: #fff;
            text-align: left;
            font-size: 15px;
            font-weight: 600;
            text-indent: 3em;

            letter-spacing: 3px;
            position: absolute;

            left: 8%;
            top: 72%;
          }
        }
        .r_b_nr {
          width: 100%;
          height: 70%;
          margin-top: 5%;
          // border: #fff 1px solid;
          display: flex;
          flex-flow: row wrap;
          .r_b_nr_l {
            width: 55%;
            height: 100%;
            // border: #fff 1px solid;
            display: flex;
            flex-flow: row wrap;

            .nr_ls {
              width: 80%;
              height: 18%;
              // margin-top: 3%;
              margin-left: 10%;

              background: url("../assets/img/gbzntjsyzt/img/wa.png") no-repeat
                top center;
              background-size: 100% 100%;
              color: #fff;
              font-size: 16px;

              display: flex;
              align-items: center; /* 主轴上垂直居中 */
              justify-content: center; /* 交叉轴上水平居中 */
            }
          }
          .r_b_nr_r {
            flex: 1;
            height: 90%;
          }
        }
      }
    }
  }
  .db_bg {
    width: 100%;

    height: 4%;
    background: url("../assets/img/gbzntjsyzt/img/db.png") no-repeat top center;
    background-size: 100% 100%;
  }
}
#n_sxt .d-player-wrap,#m_t_sp .d-player-wrap {
  object-fit: cover;
  // background-color: #ff0000 !important;
  background-color: transparent !important; /* 设置背景色为透明 */
}
@keyframes bianda {
  0% {
    opacity: 0.3;
    // transform: scale(1);
  }
  50% {
    opacity: 1;
    // transform: scale(0.5);
  }
  100% {
    opacity: 0.6;
    // transform: scale(1);
  }
}
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes daxiao {
  0%{                     
       transform: scale(0.96);
  } 
  50%{
    transform: scale(1);
  }
   100%{
    transform: scale(0.96);
  }
}

@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
   100% {
    transform: rotate(0);
  }
}
</style>
